export const SIGN_IN = 'SIGN_IN';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
